var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 7.08301L8.28494 8.53251C9.71425 9.37759 10.2856 9.37759 11.7149 8.53251L14.1666 7.08301",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67989 11.23C1.73437 13.7846 1.7616 15.0619 2.70421 16.0081C3.64682 16.9544 4.95869 16.9873 7.58244 17.0532C9.1995 17.0939 10.8007 17.0939 12.4178 17.0532C15.0415 16.9873 16.3533 16.9544 17.2959 16.0081C18.2386 15.0619 18.2658 13.7846 18.3203 11.23C18.3378 10.4086 18.3378 9.59202 18.3203 8.77068C18.2658 6.21604 18.2386 4.93873 17.2959 3.99254C16.3533 3.04635 15.0415 3.01339 12.4178 2.94747C10.8007 2.90683 9.1995 2.90683 7.58243 2.94746C4.95869 3.01338 3.64682 3.04633 2.70421 3.99253C1.7616 4.93873 1.73436 6.21603 1.67989 8.7706C1.66237 9.59202 1.66237 10.4086 1.67989 11.23Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutline);
export default __webpack_public_path__ + "static/media/email-outline.c1e5a21eb60b70556ef8406b1a744a5a.svg";
export { ForwardRef as ReactComponent };